<template>
    <div class="share-box">
        <shareTop />
        <div class="share-con font-28">
            <div class="share-info">
                <div class="share-name">
                    <h1 class="ellipsis font-40">{{ info.name }}</h1>
                </div>
                <ul class="recruit-text color-6">
                    <li>
                        <span class="recruit-label">开始时间：</span>
                        <div class="recruit-con">
                            <p>{{ info.startTime }}</p>
                        </div>
                    </li>
                    <li>
                        <span class="recruit-label">结束时间：</span>
                        <div class="recruit-con">
                            <p>{{ info.endTime }}</p>
                        </div>
                    </li>
                    <li>
                        <span class="recruit-label">活动地点：</span>
                        <div class="recruit-con">
                            <p>{{ info.provinceCodeDesc + info.cityCodeDesc + info.areaCodeDesc + info.streetCodeDesc + info.detailAddress }}</p>
                        </div>
                    </li>
                    <li>
                        <span class="recruit-label">主办方：</span>
                        <div class="recruit-con">
                            <p>{{ info.comname }}</p>
                        </div>
                    </li>
                    <li>
                        <span class="recruit-label">热线：</span>
                        <div class="recruit-con">
                            <p>{{ info.phone }}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="share-bar"></div>
             <!-- 详情文本 -->
            <div class="share-detail">
                <div class="share-text font-28 color-6">
                    <!-- <p>1、负责西瓜视频的UI/UX设计工作（加分项：有成熟的剪辑拍摄/玩法活动/视觉相关的经验）；</p>
                    <p>2、和产品一起构思创意，灵活提供行之有效的设计解决方案，平衡商业、技术与用户体验的关系；</p>
                    <p>3、统筹和推动项目，把控设计产出，制定设计规范，跟踪并还原成果，通过创新方案解决产品难题；</p>
                    <p>4、时刻分析关注流行产品设计趋势，研究目标用户审美倾向并优化现有产品。</p>
                    <br>
                    <img src="@/assets/temp/img.png" alt="" srcset="" />
                    <br>
                    <p>1、将用户体验、前沿技术与商业价值有机融合，探索千亿级营收的新兴市场，让你的设计背后蕴藏着不可估量的商业价值；</p>
                    <p>2、在广阔的发展空间下，用设计创造力打造出更多行业独角兽产品，你的每一个创意都有可能改善亿万用户的生活；</p>
                    <p>3、扁平、务实高效的组织体系，搭配系统化的人才培养机制，结合最具正能量的团队氛围，帮助每位成员快速成长，收获最专业的设计方法论和经验总结；</p> -->
                    <p>{{ info.introduce }}</p>
                </div>
            </div>
        </div>
        <shareBot />
    </div>
</template>

<script>
import shareTop from '@/components/shareTop.vue'
import shareBot from '@/components/shareBot.vue'
import Api from '@/request/api'
export default {
    name: 'sharePosition',
    components: {
        shareTop,
        shareBot
    },
    data() {
        return {
            id: this.$route.query.id,
            info: {}
        }
    },
    created() {
        this.getInfo()
    },
    methods: {
        async getInfo() {
            const res = await Api.getPeixun(this.id)
            if (!res) return
            this.info = res
        }
    }
}
</script>

<style lang="scss" scoped>
    $main-color: #0095DF;
</style>
